export default __webpack_public_path__ + "4bfee8feaec597012889ab7c0446e338.png";